// Custom Javascript

// ### Update badge variant
document.addEventListener("DOMContentLoaded", () => {
    subscribe(PUB_SUB_EVENTS.variantChange, (response) => {
        const parentNode = response.data.html;
        if(document.querySelector('.badge__custom')) document.querySelector('.badge__custom').innerHTML = parentNode.querySelector('.badge__custom')?.innerHTML;
        // if(document.querySelector('product-sticky-form')) document.querySelector('product-sticky-form').innerHTML = parentNode.querySelector('product-sticky-form')?.innerHTML;
    });
});